import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

import Users from '../views/Users/Index'
import UsersCreate from '../views/Users/Create'
import UserEdit from '../views/Users/Edit'


import Department from '../views/Department/index'

import Category from '../views/Category/index'
import Machine from '../views/Machine/index'
import Subcategory from '../views/Subcategory/index'

import Product from '../views/Product/Index'
import ProductCreate from '../views/Product/Create'
import ProductEdit from '../views/Product/Edit'
import ProductDeactive from '../views/Product/IndexDeactive'

import ReportProduct from '../views/ReportProduct/Index'
import ReportStock from '../views/ReportStock/Index'
import ReportProductDetail from '../views/ReportProductDetail/Index'
import ReportProductStock from '../views/ReportProductStock/Index'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/Users',
    name: 'Users',
    component: Users
  },
  {
    path: '/UsersCreate',
    name: 'UsersCreate',
    component: UsersCreate
  },
  {
    path: '/Users/:id',
    name: 'UsersEdit',
    component: UserEdit
  },

  {
    path: '/Department',
    name: 'Department',
    component: Department
  },

  {
    path: '/Category',
    name: 'Category',
    component: Category
  },

  {
    path: '/Product',
    name: 'Product',
    component: Product
  },

  {
    path: '/ReportProduct',
    name: 'ReportProduct',
    component: ReportProduct
  },
  {
    path: '/ReportStock',
    name: 'ReportStock',
    component: ReportStock
  },
  {
    path: '/ReportProductDetail',
    name: 'ReportProductDetail',
    component: ReportProductDetail
  },
  {
    path: '/ReportProductStock',
    name: 'ReportProductStock',
    component: ReportProductStock
  },

  {
    path: '/Machine',
    name: 'Machine',
    component: Machine
  },

  {
    path: '/ProductCreate',
    name: 'ProductCreate',
    component: ProductCreate
  },

  {
    path: '/Product/:id',
    name: 'ProductEdit',
    component: ProductEdit
  },

  {
    path: '/ProductDeactive',
    name: 'Product Deactive',
    component: ProductDeactive
  },

 {
    path: '/Subcategory/:id',
    name: 'Subcategory',
    component: Subcategory
  },


  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
